<template>
  <div>
    <!-- {{ modelFilter }} -->
    <div id="page-user-list">
      <vx-card
        ref="filterCard1"
        title="Filters"
        class="user-list-filters mb-8"
        :refresh-content-action="true"
        :collapse-action="true"
        @refresh="resetColFilters"
      >
        <div class="vx-row">
          <div class="vx-col md:w-1/1 sm:w-1/1 w-full">
            <div class="label-text">
              Project Status
            </div>
            <!-- <v-select
              :options="optionStatus"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              class="mb-4 md:mb-0"
              v-model="modelFilter.projectStatus"
              label="Text"
              :reduce="(optionStatus) => optionStatus.Value"
            /> -->
            <!-- <vs-checkbox v-model="statusList" vs-value="1">Initiate</vs-checkbox
            ><vs-checkbox v-model="statusList" vs-value="2"
              >Bidding Process</vs-checkbox
            ><vs-checkbox v-model="statusList" vs-value="3">Close</vs-checkbox> -->
            <!-- <ul class="custom">
              <li>
                <vs-checkbox v-model="modelFilter.projectStatus" vs-value="1"
                  >Project Creation
                  <span class="text-grey"
                    >(Draft | Waiting for Approval | Return | Approved)</span
                  ></vs-checkbox
                >
              </li>
              <li>
                <vs-checkbox v-model="modelFilter.projectStatus" vs-value="2"
                  >Project Bidding
                  <span class="text-grey">
                    (Open Bidding | Close Bidding | Bidding Evaluate, Bidding
                    Negotiate | Waiting Final Price)
                  </span></vs-checkbox
                >
              </li>
              <li>
                <vs-checkbox v-model="modelFilter.projectStatus" vs-value="3"
                  >Project Closing
                  <span class="text-grey"
                    >(Rejected | Cancel | Award)</span
                  ></vs-checkbox
                >
              </li>
            </ul> -->
          </div>
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col md:w-1/1 sm:w-1/1 w-full">
            <vs-checkbox v-model="modelFilter.projectStatus" vs-value="1"
              >Project Creation
              <span class="text-grey"
                >( Draft | Waiting for Approval | Return | Approved )</span
              ></vs-checkbox
            >
          </div>
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col md:w-1/1 sm:w-1/1 w-full">
            <vs-checkbox v-model="modelFilter.projectStatus" vs-value="2"
              >Project Bidding
              <span class="text-grey">
                ( Open Bidding | Close Bidding | Bidding Evaluate, Bidding
                Negotiate | Waiting Final Price )
              </span></vs-checkbox
            >
          </div>
        </div>
        <div class="vx-row mb-5">
          <div class="vx-col md:w-1/1 sm:w-1/1 w-full">
            <vs-checkbox v-model="modelFilter.projectStatus" vs-value="3"
              >Project Closing
              <span class="text-grey"
                >( Rejected | Cancel | Award )</span
              ></vs-checkbox
            >
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col md:w-1/5 sm:w-1/5 w-full">
            <div class="label-text">
              Procurement Team
            </div>
            <v-select
              :options="optionProcurementTeam"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              class="mb-4 md:mb-0"
              v-model="modelFilter.procurementTeam"
              label="departmentName"
              :reduce="
                (optionProcurementTeam) =>
                  optionProcurementTeam.prefixProjcetCode
              "
            />
          </div>

          <div class="vx-col md:w-1/5 sm:w-1/5 w-full">
            <div class="label-text">
              Bidding Start Date
            </div>
            <flat-pickr class="w-full" v-model="modelFilter.startDate" />
          </div>
          <div class="vx-col md:w-1/5 sm:w-1/5 w-full">
            <div class="label-text">
              Bidding End Date
            </div>
            <flat-pickr class="w-full" v-model="modelFilter.endDate" />
          </div>
        </div>
      </vx-card>

      <vx-card
        ref="filterCard"
        title="Project List"
        class="user-list-filters mb-8"
      >
        <div class="vx-row">
          <div class="vx-col md:w-1/1 sm:w-1/1 w-full">
            <vs-table
              pagination
              search
              max-items="20"
              :data="data"
              :stripe="true"
              v-if="data != null"
              v-model="selected"
              @selected="redirect(selected)"
            >
              <template slot="thead">
                <vs-th sort-key="projectCode">Project Code</vs-th>
                <vs-th sort-key="subject">Subject</vs-th>
                <vs-th sort-key="referenceNo">Ref No.</vs-th>
                <vs-th sort-key="createdBy">Purchaser</vs-th>
                <vs-th sort-key="projectOwnerName">Requester</vs-th>
                <vs-th sort-key="startDate">Bidding Start Date</vs-th>
                <vs-th sort-key="endDate">Bidding End Date</vs-th>
                <vs-th sort-key="isPublic">Public</vs-th>
                <vs-th sort-key="projectStatus">Status</vs-th>
                <vs-th sort-key="action">Action</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <!-- <vs-td :data="indextr">
                  {{ indextr }}
                </vs-td> -->
                  <vs-td :data="data[indextr].projectCode">
                    {{ data[indextr].projectCode }}
                  </vs-td>
                  <vs-td :data="data[indextr].subject">
                    {{ data[indextr].subject }}
                  </vs-td>
                   <vs-td :data="data[indextr].prpo">
                    {{ data[indextr].prpo }}
                  </vs-td>
                  <vs-td :data="data[indextr].contactPointName">
                    {{ data[indextr].contactPointName }}
                  </vs-td>
                  <vs-td :data="data[indextr].projectOwnerName">
                    {{ data[indextr].projectOwnerName }}
                  </vs-td>
                  <vs-td :data="data[indextr].startDate">
                    {{ format(data[indextr].startDate) }}
                  </vs-td>
                  <vs-td :data="data[indextr].endDate">
                    {{ format(data[indextr].endDate) }}
                  </vs-td>
                  <vs-td :data="data[indextr].isPublic">
                    <vs-chip
                      color="success"
                      transparent
                      v-if="data[indextr].isPublic"
                      >Yes</vs-chip
                    >
                    <vs-chip
                      color="warning"
                      transparent
                      v-if="!data[indextr].isPublic"
                      >No</vs-chip
                    >
                  </vs-td>
                  <vs-td :data="data[indextr].projectStatus">
                    <vs-chip
                      transparent
                      :color="setChipStatusColor(data[indextr].projectStatus)"
                      >{{ data[indextr].projectStatus }}</vs-chip
                    >
                  </vs-td>
                  <vs-td>
                    <router-link :to="setUrlRedirect(tr.projectId)">
                      <feather-icon
                        icon="EyeIcon"
                        svgClasses="w-5 h-5 hover:text-primary stroke-current"
                      />
                    </router-link>
                    <feather-icon
                      v-if="tr.projectStatus == 'Draft'"
                      icon="TrashIcon"
                      svgClasses="w-5 h-5 hover:text-danger stroke-current"
                      class="ml-2"
                      @click.stop="deleteProject(tr.projectId)"
                    />
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
            <pre v-if="data == null">No data Available.</pre>
          </div>
        </div>
      </vx-card>
    </div>
    <vs-prompt
      class="calendar-event-dialog"
      title="Reason"
      accept-text="Submit"
      @accept="saveComment"
      :active.sync="activePromptSaveComment"
    >
      <vs-textarea v-model="deleteComment" class="mt-5" />
    </vs-prompt>
  </div>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

import { _masterservices } from "../../services/masterservices";
import { _projectservices } from "../../services/projectservices";
import { dateFormat } from "../../services/utility";

export default {
  components: {
    vSelect,
    flatPickr,
  },
  data() {
    return {
      activePromptSaveComment: false,
      deleteComment: "",
      /* optionStatus: [
        { Value: 0, Text: "All" },
        { Value: 1, Text: "Initiate" },
        { Value: 2, Text: "On Process" },
        { Value: 3, Text: "Closed" },
      ], */

      optionStatus: [
        { Value: "1", Text: "Initiate" },
        { Value: "2", Text: "Bidding Process" },
        { Value: "3", Text: "Close" },
      ],

      optionCompany: [],

      optionProcurementTeam: [],

      data: [],
      selected: {},

      modelFilter: {
        startDate: null,
        endDate: null,
        procurementTeam: "",
        projectStatus: ["1", "2", "3"],
      },

      id: 0,
    };
  },

  created() {
    // this.getMasterCompany();
    this.getProcurementTeam();
    this.getProjectList();

    // this.allStorage();
  },

  methods: {
    resetColFilters() {
      this.modelFilter.startDate = null;
      this.modelFilter.endDate = null;
      this.modelFilter.procurementTeam = null;
      this.modelFilter.projectStatus = [];

      this.$refs.filterCard1.removeRefreshAnimation();
    },

    redirect(item) {
      var url = this.setUrlRedirect(item.projectId);
      this.$router.push(url).catch(() => {});
    },

    deleteProject(id) {
      this.id = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm Delete Project`,
        text: `Are you sure to delete this project?`,
        accept: this.accept,
      });
    },
    async accept() {
      this.deleteComment = "";
      this.activePromptSaveComment = true;
    },

    async saveComment() {
      const deleteData = {
        projectId: this.id,
        remark: this.deleteComment,
      };

      this.$vs.loading({
        type: "sound",
      });

      this.data = await _projectservices.DeleteBiddingProject(deleteData);

      this.getProjectList();

      this.$vs.loading.close();

      this.$vs.notify({
        color: "success",
        title: "Delete project success",
      });
    },

    async getMasterCompany() {
      this.optionCompany = await _masterservices.GetMasterCompany();
      // console.log(this.optionCompany);
    },

    async getProcurementTeam() {
      this.optionProcurementTeam = await _masterservices.GetMasterProcurementDept();
      // console.log(this.optionProcurementTeam);
    },

    async getProjectList() {
      if (this.modelFilter.endDate < this.modelFilter.startDate) {
        // this.modelFilter.startDate = null;
        // this.modelFilter.endDate = null;

        this.$vs.notify({
          color: "danger",
          title: "Bidding end date not before Bidding end date",
        });
      } else {
        this.$vs.loading({
          type: "sound",
        });

        this.data = await _projectservices.GetProjectList(this.modelFilter);
        // console.log(this.data);

        this.$vs.loading.close();
      }
    },

    setUrlRedirect(id) {
      return "/procurement-management/project/view/" + id;
    },

    format(date) {
      return dateFormat(date);
    },

    setChipStatusColor(status) {
      let color = "";
      if (status == "WaitingApproval") {
        color = "warning";
      }

      if (
        /*  status == "Draft" ||
        status == "WaitingApproval" ||
        status == "Return" || */
        status == "Approved"
      ) {
        color = "#6AB96F";
      }

      if (
        status == "OpenBidding" ||
        status == "CloseBidding" ||
        status == "BiddingEvaluate" ||
        status == "BiddingNegotiate" ||
        status == "WaitingFinalPrice"
      ) {
        color = "primary";
      }

      if (status == "Rejected" || status == "Cancel") {
        color = "danger";
      }

      return color;
    },

    allStorage() {
      var values = [],
        keys = Object.keys(localStorage),
        i = keys.length;

      while (i--) {
        values.push(localStorage.getItem(keys[i]));
      }

      console.log(values);
    },
  },

  watch: {
    modelFilter: {
      deep: true,
      handler() {
        // console.log(this.modelFilter.startDate);
        if (this.modelFilter.startDate == "") this.modelFilter.startDate = null;
        if (this.modelFilter.endDate == "") this.modelFilter.endDate = null;

        this.getProjectList();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.label-text {
  padding-bottom: 10px;
  color: #103a5d;
  font-weight: 500;
}

ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

li {
  margin-right: 10px;
  float: left;
}

.text-grey {
  font-size: 10pt;
}
</style>
